





































































































































































import { Component, Vue, Watch } from "vue-property-decorator";

import {
  WeekTimetablesInterface,
  DayInterface,
  PolyDialogTypeInterface,
  MealInterface,
  TimeTableItemUpdateInterface,
  FlattenedLists,
  RandomisedObjectInterface,
  MyTimetablesAddWeekOperationsInterface
} from "@/interfaces";

import { Randomise, RandomisedListsInterface } from "@/logic/index.ts";

@Component({
  components: {}
})
export default class MyTimetablesPage extends Vue {
  toastMessage: string = "";
  toast: boolean = false;

  weekname: string = "First week";
  activeIndex = 0;

  timetablesArray: Array<Array<DayInterface>> = [];

  // Store states in JSON
  timetableArrayStates: Array<string> = [];
  timetableArrayAboutToBeModified: string | undefined;

  DIALOG_OPEN_EVENT = "OPEN_DIALOG";
  PAGE_DIALOG_EVENT = "MY_TIMETABLES_PAGE_DIALOG";

  ADD_WEEK_EVENT = "ADD_WEEK_OPS";

  @Watch("activeIndex")
  slideChange(val: number): void {
    if (this.activeIndex < 3) this.weekname = "First week";
    else this.weekname = "Second week";
  }

  @Watch("timetablesArray", { immediate: true })
  onTimeTableArrayChange(val: Array<Array<DayInterface>>): void {
    if (val.length === 6) this.sendDisableAddWeekEvent();
    else this.sendEnableAddWeekEvent();
  }

  mounted() {
    this.setUpPageDialogListener();
    this.setUpWeekOpsListener();
    this.setCurrentTimetable();
  }

  beforeDestroy() {
    this.checkTimetableChangesAndUpdateServiceData();
    // this.$root.$off(this.DIALOG_OPEN_EVENT)
    // this.$root.$off(this.PAGE_DIALOG_EVENT)
    // this.$root.$off(this.ADD_WEEK_EVENT)
  }

  checkTimetableChangesAndUpdateServiceData(): void {
    // @ts-ignore
    const serviceTimetable: Array<Array<
      DayInterface
    >> = this.$dataService.getCurrentTimetable();
    // @ts-ignore

    const jsonnifiedServiceTimetable: string = JSON.stringify(serviceTimetable);
    const jsonnifiedUpdatedTimetable: string = JSON.stringify(
      this.timetablesArray
    );

    if (jsonnifiedServiceTimetable === jsonnifiedUpdatedTimetable) {
      return;
    }

    let updateMessage: string = "";

    if (this.timetablesArray.length === serviceTimetable.length)
      updateMessage = "Spiced up the timetable";

    const serviceTimetablesHaveNothing: boolean = serviceTimetable.length === 0;
    const ourTimetablesHaveNothing: boolean = this.timetablesArray.length === 0;

    const serviceTimetablesHave1Week: boolean = serviceTimetable.length === 3;
    const ourTimetablesHave1Week: boolean = this.timetablesArray.length === 3;

    const serviceTimetablesHave2Weeks: boolean = serviceTimetable.length === 6;
    const ourTimetablesHave2Weeks: boolean = this.timetablesArray.length === 6;

    if (
      (serviceTimetablesHaveNothing && ourTimetablesHave1Week) ||
      (serviceTimetablesHave1Week && ourTimetablesHave2Weeks)
    )
      updateMessage = "Added a week to the timetable";

    if (serviceTimetablesHaveNothing && ourTimetablesHave2Weeks)
      updateMessage = "Added 2 weeks to the timetable";

    if (serviceTimetablesHave2Weeks && ourTimetablesHave1Week)
      updateMessage = "Removed a week from the timetable";

    if (ourTimetablesHaveNothing)
      updateMessage = "Removed the entire timetable";

    // @ts-ignore
    this.$dataService.updateTimetableArrayFromMyTimetablesPage(
      this.timetablesArray,
      updateMessage
    );
  }

  setCurrentTimetable(): void {
    // @ts-ignore
    this.timetablesArray = JSON.parse(
      // @ts-ignore
      JSON.stringify(this.$dataService.getCurrentTimetable())
    );
  }

  setUpPageDialogListener(): void {
    this.$root.$on(
      this.PAGE_DIALOG_EVENT,
      (update: PolyDialogTypeInterface) => {
        if (!update) return;

        if (update.editTimetableItemSelected)
          this.handleTimeTableItemUpdate(update);
        if (update.addWeekSelected) this.addAWeek();
        if (update.removeWeekSelected) this.removeAWeek();
      }
    );
  }

  setUpWeekOpsListener(): void {
    this.$root.$on(
      this.ADD_WEEK_EVENT,
      (weekOp: MyTimetablesAddWeekOperationsInterface) => {
        if (weekOp.addWeek) this.openAddWeekDialog();
      }
    );
  }

  sendDisableAddWeekEvent(): void {
    const weekOp: MyTimetablesAddWeekOperationsInterface = {
      activateButton: false
    };

    this.$root.$emit(this.ADD_WEEK_EVENT, weekOp);
  }

  sendEnableAddWeekEvent(): void {
    const weekOp: MyTimetablesAddWeekOperationsInterface = {
      activateButton: true
    };

    this.$root.$emit(this.ADD_WEEK_EVENT, weekOp);
  }

  slidePrev(): void {
    if (this.activeIndex !== 0) this.activeIndex--;
  }

  slideForward(): void {
    if (this.activeIndex !== this.timetablesArray.length - 1)
      this.activeIndex++;
  }

  openAddWeekDialog(): void {
    const addWeekNumber = !this.activeIndex ? 0 : 1;

    const polyDialogData: PolyDialogTypeInterface = {
      addWeekSelected: true,
      addWeekNumber
    };

    this.openDialog(polyDialogData);
  }

  openRemoveWeekDialog(): void {
    const removeWeekNumber = this.activeIndex < 3 ? 1 : 2;

    const polyDialogData: PolyDialogTypeInterface = {
      removeWeekSelected: true,
      removeWeekNumber
    };

    this.openDialog(polyDialogData);
  }

  openItemEditDialog(
    timetableItemIndex: number,
    dayIndex: number,
    mealIndex: number,
    item: MealInterface
  ): void {
    const editTimetableItem: TimeTableItemUpdateInterface = {
      timetableItemIndex,
      dayIndex,
      mealIndex,
      item
    };

    const polyDialogData: PolyDialogTypeInterface = {
      editTimetableItemSelected: true,
      editTimetableItem
    };
    this.openDialog(polyDialogData);
  }

  openDialog(data: PolyDialogTypeInterface): void {
    this.preStoreTimetableArrayState();
    data.pageEvent = this.PAGE_DIALOG_EVENT;

    this.$root.$emit(this.DIALOG_OPEN_EVENT, data);
  }

  handleTimeTableItemUpdate(update: PolyDialogTypeInterface): void {
    this.storeTimetableArrayState();

    const item = update.editTimetableItem as TimeTableItemUpdateInterface;
    this.timetablesArray[item.timetableItemIndex][item.dayIndex].meals[
      item.mealIndex
    ] = item.item;
  }

  preStoreTimetableArrayState(): void {
    this.timetableArrayAboutToBeModified = JSON.stringify(this.timetablesArray);
  }

  checkAndRemovePreviouslyStoredTimetableStates(): void {
    if (this.timetableArrayStates.length === 20)
      this.timetableArrayStates.shift();
  }

  storeTimetableArrayState(): void {
    if (this.timetablesArray.length === 0) return;

    this.checkAndRemovePreviouslyStoredTimetableStates();
    this.timetableArrayStates.push(this.timetableArrayAboutToBeModified as any);
  }

  restorePreviousTimetableState(): void {
    this.activeIndex = 0;
    const lastTimeTableArrayItem = this.timetableArrayStates.pop();

    if (lastTimeTableArrayItem) {
      this.timetablesArray = JSON.parse(lastTimeTableArrayItem as string);
      this.showToast("Restored");
    }
  }

  addAWeek(): void {
    this.storeTimetableArrayState();

    const newWeekArrays: Array<Array<DayInterface>> = Array.from(
      { length: 3 },
      (_, index) => {
        const arrayItemLength = index === 2 ? 1 : 3;

        return Array.from({ length: arrayItemLength }, (_, dayIndex) => {
          const day =
            index === 0 && dayIndex === 0
              ? "mon"
              : index === 0 && dayIndex === 1
              ? "tue"
              : index === 0 && dayIndex === 2
              ? "wed"
              : index === 1 && dayIndex === 0
              ? "thu"
              : index === 1 && dayIndex === 1
              ? "fri"
              : index === 1 && dayIndex === 2
              ? "sat"
              : "sun";

          return {
            day,
            meals: Array.from({ length: 3 }, (_, mealIndex) => {
              const title =
                mealIndex === 0
                  ? "breakfast"
                  : mealIndex === 1
                  ? "lunch"
                  : "supper";

              return { title, value: null, notes: null };
            })
          };
        }) as any;
      }
    ) as Array<Array<DayInterface>>;

    if (this.timetablesArray.length > 0) this.activeIndex = 0;

    // // console.log({ newWeekArrays })
    this.timetablesArray.push(...newWeekArrays);
  }

  removeFirstWeek(): void {
    // pop 2.3 1 -> 1.3 1
    this.timetablesArray.shift();
    // pop 2.2 3 -> 1.2 3
    this.timetablesArray.shift();
    // pop 2.1 3 -> 1.1 3
    this.timetablesArray.shift();
  }

  removeLastWeek(): void {
    // pop 2.3 1 -> 1.3 1
    this.timetablesArray.pop();
    // pop 2.2 3 -> 1.2 3
    this.timetablesArray.pop();
    // pop 2.1 3 -> 1.1 3
    this.timetablesArray.pop();
  }

  removeAWeek(): void {
    this.storeTimetableArrayState();

    const slideInFirstWeek = this.activeIndex < 3;

    if (slideInFirstWeek) {
      if (this.timetablesArray.length > 3) this.activeIndex = 0;

      this.removeFirstWeek();
    } else {
      this.removeLastWeek();

      if (this.timetablesArray.length > 0 && this.activeIndex > 2)
        this.activeIndex = 2;
    }
  }

  randomiseTimetable(): void {
    this.preStoreTimetableArrayState();
    this.storeTimetableArrayState();

    //@ts-ignore
    const flattenedLists: FlattenedLists = this.$dataService.getFlattenedTimetableArrayList(
      this.timetablesArray
    );
    //@ts-ignore
    const randomisedLists: RandomisedListsInterface<MealInterface> = this.$dataService.getRandomisedLists(
      // @ts-ignore
      flattenedLists
    );
    //@ts-ignore
    const indexedItems: Array<RandomisedObjectInterface> = this.$dataService.getIndexedRandomisedList(
      // @ts-ignore
      randomisedLists
    );

    //@ts-ignore
    this.timetablesArray = this.$dataService.updateAndGetTimeTableArrayWithIndexedList(
      indexedItems,
      this.timetablesArray
    );

    this.showToast("Changed your timetable order for you...");
  }

  showToast(message: string): void {
    const simpleMessage = message.toLowerCase();

    if (
      simpleMessage.includes("typeerror") ||
      simpleMessage.includes("network")
    )
      return;
    else if (
      simpleMessage.includes("html") ||
      simpleMessage.includes("undefined")
    )
      message = "Please try again later";

    this.toastMessage = message;
    this.toast = true;
  }
}
